import React, {useEffect, useState} from "react";
import "../../styles/BandcampFolder.css";
import icon from "../../assets/images/bandcamp.png";
import Draggable from "react-draggable";

const BandcampFolder = ({ name, onClick }) => {
    const [isDesktop, setIsDesktop] = useState(true);
        const [clickCount, setClickCount] = useState(0);
    
        useEffect(() => {
            const checkDevice = () => {
                setIsDesktop(!("ontouchstart" in window || navigator.maxTouchPoints > 0));
            };
            checkDevice();
            window.addEventListener("resize", checkDevice);
            return () => window.removeEventListener("resize", checkDevice);
        }, []);
    
        const handleClick = () => {
            setClickCount((prevCount) => prevCount + 1);
    
            setTimeout(() => {
                setClickCount(0);
            }, 300);
            if (clickCount === 1) {
                onClick();
            }
        };
    return isDesktop ?(
        <Draggable>
        <div className="bandcamp">
            <div onClick={handleClick}>
            <img src={icon} alt="bandcamp icon"/>
            <span>{name}</span>
            </div>
        </div>
        </Draggable>
    ) : (
        <div className="bandcamp" onClick={onClick}>
            <img src={icon} alt="bandcamp icon"/>
            <span>{name}</span>
        </div>
    );
};

export default BandcampFolder;